import React, { useEffect, useState } from "react";
import {
    Box,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Container,
    Typography,
    useMediaQuery,
    CircularProgress,
    Grid,
    Tabs,
    Tab,
    List,
    ListItemButton,
    ListItemText,
    Divider,
} from "@mui/material";
import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import {
    collection,
    getDocs,
    query,
    limit,
    orderBy,
    startAfter,
    where,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import InfiniteScroll from "react-infinite-scroller";

import LockIcon from "@mui/icons-material/Lock";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DescriptionIcon from "@mui/icons-material/Description";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

function Mylist() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [user, setUser] = useState("");

    const [tabValue, setTabValue] = useState(0);

    const [charaData, setCharaData] = useState([]);
    const [scinaData, setScinaData] = useState([]);

    const [scinaHasMore, setScinaHasMore] = useState(true);
    const [scinaLastVisible, setScinaLastVisible] = useState(null);

    const [charaHasMore, setCharaHasMore] = useState(true);
    const [charaLastVisible, setCharaLastVisible] = useState(null);

    const isSP = useMediaQuery("(max-width:600px)");
    const charaWidth = isSP ? 170 : 350;
    const charaMx = isSP ? 1 : 1.5;
    const deadFont = isSP ? 80 : 170;

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleTransScina = (id) => {
        window.scrollTo(0, 0);
        navigate(`/scinario/${id}`);
    };

    const handleTransChara = (id) => {
        window.scrollTo(0, 0);
        navigate(`/character/${id}`);
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                setUser(userLogin.uid);
                await fetchData(userLogin.uid);
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });
        return () => unsubscribe();
    }, []);

    const fetchData = async (uid) => {
        const charaRef = collection(db, "character");
        const scinaRef = collection(db, "scinario");
        const userRef = collection(db, "member");

        try {
            const q = query(
                charaRef,
                where("deleted", "==", false),
                where("auther", "==", uid),
                orderBy("updateAt", "desc"),
                limit(10)
            );
            const charaSnap = await getDocs(q);

            if (charaSnap.empty) {
                setCharaHasMore(false);
            } else {
                const charas = [];
                charaSnap.forEach((doc) => {
                    const timestamp = doc.data().updateAt.seconds;
                    const date = new Date(timestamp * 1000);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");
                    const hours = String(date.getHours()).padStart(2, "0");
                    const minutes = String(date.getMinutes()).padStart(2, "0");
                    const seconds = String(date.getSeconds()).padStart(2, "0");
                    const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

                    charas.push({
                        img: doc.data().img,
                        id: doc.data().id,
                        name: doc.data().name,
                        furi: doc.data().furi,
                        auther: doc.data().auther,
                        updateAt: formattedDate,
                        private: doc.data().private,
                        dead: doc.data().dead,
                    });
                });
                setCharaData(charas);

                setCharaLastVisible(charaSnap.docs[charaSnap.docs.length - 1]);
            }
        } catch (error) {
            console.log("error: ", error);
        }

        try {
            const q = query(
                scinaRef,
                where("deleted", "==", false),
                where("auther", "==", uid),
                orderBy("updateAt", "desc"),
                limit(10)
            );
            const scinaSnap = await getDocs(q);

            if (scinaSnap.empty) {
                setScinaHasMore(false);
            } else {
                const scinas = [];
                scinaSnap.forEach((doc) => {
                    const timestamp = doc.data().updateAt.seconds;
                    const date = new Date(timestamp * 1000);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");
                    const hours = String(date.getHours()).padStart(2, "0");
                    const minutes = String(date.getMinutes()).padStart(2, "0");
                    const seconds = String(date.getSeconds()).padStart(2, "0");
                    const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

                    scinas.push({
                        id: doc.data().id,
                        title: doc.data().title,
                        auther: doc.data().auther,
                        updateAt: formattedDate,
                        private: doc.data().private,
                        clear: doc.data().clear,
                    });
                });

                const q2 = query(
                    userRef,
                    where(
                        "uid",
                        "in",
                        scinas.map((user) => user.auther)
                    )
                );
                const inputSnap = await getDocs(q2);
                const updateScinas = scinas.map((scina) => {
                    const matchingDoc = inputSnap.docs.find(
                        (doc) => doc.data().uid === scina.auther
                    );
                    if (matchingDoc) {
                        return {
                            ...scina,
                            name: matchingDoc.data().name,
                        };
                    }
                    return scina;
                });
                setScinaData(updateScinas);

                setScinaLastVisible(scinaSnap.docs[scinaSnap.docs.length - 1]);
            }
        } catch (error) {
            console.log("error: ", error);
        }
        setLoading(false);
    };

    const fetchCharaMoreData = async () => {
        const charaRef = collection(db, "character");

        try {
            const q = query(
                charaRef,
                where("deleted", "==", false),
                where("auther", "==", user),
                orderBy("updateAt", "desc"),
                limit(10),
                startAfter(charaLastVisible)
            );
            const charaSnap = await getDocs(q);

            if (charaSnap.empty) {
                setCharaHasMore(false);
                return;
            }

            const charas = [];
            charaSnap.forEach((doc) => {
                const timestamp = doc.data().updateAt.seconds;
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

                charas.push({
                    img: doc.data().img,
                    id: doc.data().id,
                    name: doc.data().name,
                    auther: doc.data().auther,
                    updateAt: formattedDate,
                    private: doc.data().private,
                    dead: doc.data().dead,
                });
            });
            setCharaData((prevData) => [...prevData, ...charas]);

            setCharaLastVisible(charaSnap.docs[charaSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }
    };

    const fetchScinaMoreData = async () => {
        const userRef = collection(db, "member");
        const scinaRef = collection(db, "scinario");

        try {
            const q = query(
                scinaRef,
                where("deleted", "==", false),
                orderBy("updateAt", "desc"),
                limit(10),
                startAfter(scinaLastVisible)
            );
            const scinaSnap = await getDocs(q);

            if (scinaSnap.empty) {
                setScinaHasMore(false);
                return;
            }

            const scinas = [];
            scinaSnap.forEach((doc) => {
                const timestamp = doc.data().updateAt.seconds;
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

                scinas.push({
                    id: doc.data().id,
                    title: doc.data().title,
                    auther: doc.data().auther,
                    updateAt: formattedDate,
                    private: doc.data().private,
                    clear: doc.data().clear,
                });
            });

            const q2 = query(
                userRef,
                where(
                    "uid",
                    "in",
                    scinas.map((user) => user.auther)
                )
            );

            const inputSnap = await getDocs(q2);
            const updateScinas = scinas.map((scina) => {
                const matchingDoc = inputSnap.docs.find(
                    (doc) => doc.data().uid === scina.auther
                );
                if (matchingDoc) {
                    return {
                        ...scina,
                        name: matchingDoc.data().name,
                    };
                }
                return scina;
            });
            setScinaData((prevData) => [...prevData, ...updateScinas]);

            setScinaLastVisible(scinaSnap.docs[scinaSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }
    };

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>MyList - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Container
                maxWidth="1280"
                sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}
            >
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    centered
                    sx={{ mt: 10 }}
                >
                    <Tab
                        icon={<PeopleAltIcon />}
                        iconPosition="start"
                        label="キャラクター"
                    />
                    <Tab
                        icon={<DescriptionIcon />}
                        iconPosition="start"
                        label="シナリオ"
                    />
                </Tabs>

                <Box>
                    {tabValue === 0 ? (
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={fetchCharaMoreData}
                            hasMore={charaHasMore}
                            loader={
                                <Box
                                    sx={{ m: 1 }}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                    key={0}
                                >
                                    <CircularProgress />
                                </Box>
                            }
                        >
                            <Grid
                                container
                                sx={{ mt: 2 }}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                {charaData.map((item, i) => (
                                    <Grid
                                        item
                                        key={i}
                                        xs={5.46}
                                        sm={3.4092}
                                        sx={{
                                            my: 1,
                                            mx: charaMx,
                                        }}
                                    >
                                        <Card sx={{ position: "relative" }}>
                                            <CardActionArea
                                                onClick={() =>
                                                    handleTransChara(
                                                        item.id,
                                                        item.private,
                                                        item.auther
                                                    )
                                                }
                                            >
                                                <CardMedia
                                                    component="img"
                                                    height={charaWidth}
                                                    image={item.img}
                                                    sx={{
                                                        objectFit: "contain",
                                                    }}
                                                />
                                                {item.dead && (
                                                    <Box
                                                        sx={{
                                                            position:
                                                                "absolute",
                                                            top: -100,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            display: "flex",
                                                            justifyContent:
                                                                "center",
                                                            alignItems:
                                                                "center",
                                                            transform:
                                                                "rotate(-45deg)",
                                                            opacity: 0.7,
                                                        }}
                                                    >
                                                        <Typography
                                                            color="black"
                                                            fontWeight="bold"
                                                            sx={{
                                                                fontSize:
                                                                    deadFont,
                                                            }}
                                                        >
                                                            死亡
                                                        </Typography>
                                                    </Box>
                                                )}
                                                {item.private && (
                                                    <Box
                                                        sx={{
                                                            position:
                                                                "absolute",
                                                            display: "flex",
                                                            justifyContent:
                                                                "left",
                                                            alignItems:
                                                                "flex-start",
                                                            top: 5,
                                                            left: 5,
                                                            backgroundColor:
                                                                "rgba(0, 0, 0, 0.5)",
                                                            borderRadius: 1,
                                                        }}
                                                    >
                                                        <LockIcon
                                                            sx={{
                                                                fontSize: 30,
                                                            }}
                                                        />
                                                    </Box>
                                                )}
                                                <CardContent>
                                                    <Typography
                                                        variant="h6"
                                                        conponent="div"
                                                    >
                                                        {item.name}
                                                    </Typography>
                                                </CardContent>
                                                <CardActions
                                                    sx={{
                                                        justifyContent: "right",
                                                        display: "flex",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="caption"
                                                        color="text.secondary"
                                                    >
                                                        {item.updateAt}
                                                    </Typography>
                                                </CardActions>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </InfiniteScroll>
                    ) : (
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={fetchScinaMoreData}
                            hasMore={scinaHasMore}
                            loader={
                                <Box
                                    sx={{ m: 1 }}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                    key={0}
                                >
                                    <CircularProgress />
                                </Box>
                            }
                        >
                            <List>
                                <Divider />
                                {scinaData.map((item, i) => (
                                    <ListItemButton
                                        key={i}
                                        divider
                                        onClick={() =>
                                            handleTransScina(item.id)
                                        }
                                    >
                                        <ListItemText
                                            primary={
                                                <Typography
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <span>{item.title}</span>
                                                    <span>
                                                        {item.clear && (
                                                            <CheckCircleIcon />
                                                        )}
                                                        {item.private ===
                                                            false && (
                                                            <LockIcon />
                                                        )}
                                                    </span>
                                                </Typography>
                                            }
                                            secondary={
                                                <Typography
                                                    color="text.secondary"
                                                    variant="body2"
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "white",
                                                        }}
                                                    >
                                                        {item.name}
                                                    </span>
                                                    <span>{item.updateAt}</span>
                                                </Typography>
                                            }
                                        />
                                    </ListItemButton>
                                ))}
                            </List>
                        </InfiniteScroll>
                    )}
                </Box>
            </Container>
        </div>
    );
}

export default Mylist;
